import React, { useState, useEffect, useContext } from 'react'
import Box from '@mui/material/Box';

const mathValue = (bks, lock, cargo, setter) => {

    const value = parseInt(bks) + parseInt(lock) - parseInt(cargo)
    setter(value)
}

const DispbksBox = ({ bks, cargo, state, lock }) => {
    const [lockCargo, setLockCargo] = useState(lock);
    const [bksValue, setBksValue] = useState(bks);


    useEffect(() => {


        const safeBks = isNaN(bks) || bks === '' || bks == null ? 0 : Number(bks);

        const safeCargo = isNaN(cargo) || cargo === '' || cargo == null ? 0 : Number(cargo);

        const safeLock = isNaN(lockCargo) || lockCargo === '' || lockCargo == null ? 0 : Number(lockCargo);

        mathValue(safeBks, safeLock, safeCargo, setBksValue)
    }, [state.bksChange])

    return (
        <>
            <Box>
                {bksValue}
            </Box>
        </>
    )
}

export default DispbksBox